import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingRoutingModule } from './landing-routing.module';
import { LandingComponent } from './landing.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

export function getInitialLang(): string {
  return localStorage.getItem('lang') || 'ar';
}
export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, '../assets/i18n/public-components/landing/', '.json?v=' + environment.version);
}
@NgModule({
  declarations: [LandingComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    LandingRoutingModule,
    SharedModule,
    TranslateModule.forChild({
      defaultLanguage: getInitialLang(),
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    })
  ]
})
export class LandingModule {
}
